<header class="MuiPaper-root MuiPaper-elevation MuiPaper-elevation4 MuiAppBar-root MuiAppBar-colorPrimary MuiAppBar-positionFixed mui-fixed mui-style-wne33u">
  <div class="MuiBox-root mui-style-1l5h1fr">
    <div class="MuiToolbar-root MuiToolbar-regular mui-style-1f2p3pb">
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 mui-style-1j2yjj3">
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-7 mui-style-1m5ny0b">
          <div class="MuiBox-root mui-style-oc6i0x">
            <span
              style="
                box-sizing: border-box;
                display: inline-block;
                overflow: hidden;
                width: 120px;
                height: 50px;
                background: none;
                opacity: 1;
                border: 0;
                margin: 0;
                padding: 0;
                position: relative;
              "
              ><img
                alt="Paris 2024 Logo"
                src="{{imagePath}}/assets/images/ol/Header_OLE_En.png?imwidth=256" 
                decoding="async"
                data-nimg="fixed"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  box-sizing: border-box;
                  padding: 0;
                  border: none;
                  margin: auto;
                  display: block;
                  width: 0;
                  height: 0;
                  min-width: 100%;
                  max-width: 100%;
                  min-height: 100%;
                  max-height: 100%;
                "
            /></span>
          </div>
          <div class="header-lable">
            <h6>{{ 'Header' | clientTranslate }} <span>{{'HOMELAYOUT.PARIS 2024 OLYMPIC GAMES'| optimotranslate | uppercase}}</span></h6>
          </div>
        </div>
        
        <!-- <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-5 mui-style-15pesnb">
          <div class="mui-style-11lbm61">
            <div class="mui-style-1chazok">
              <div class="MuiBox-root mui-style-1qve9me">
                <span
                  style="
                    box-sizing: border-box;
                    display: inline-block;
                    overflow: hidden;
                    width: 120px;
                    height: 50px;
                    background: none;
                    opacity: 1;
                    border: 0;
                    margin: 0;
                    padding: 0;
                    position: relative;
                  "
                  ><img
                    alt="VISA logo"
                    src="https://corporatehospitality.paris2024.org/assets/images/Header/visaEnglishLogo.svg?imwidth=128"
                    decoding="async"
                    data-nimg="fixed"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      box-sizing: border-box;
                      padding: 0;
                      border: none;
                      margin: auto;
                      display: block;
                      width: 0;
                      height: 0;
                      min-width: 100%;
                      max-width: 100%;
                      min-height: 100%;
                      max-height: 100%;
                    "
                    srcset="
                    https://corporatehospitality.paris2024.org/assets/images/Header/visaEnglishLogo.svg?imwidth=128 1x,
                    https://corporatehospitality.paris2024.org/assets/images/Header/visaEnglishLogo.svg?imwidth=256 2x
                    "
                /></span>
              </div>
            </div>
            <div class="mui-style-u4p24i">
              <div
                class="MuiFormControl-root MuiTextField-root mui-style-1njfzyz">
                <div
                  class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-formControl mui-style-1ezotza">
                  <div
                    tabindex="0"
                    role="button"
                    aria-expanded="false"
                    aria-haspopup="listbox"
                    aria-labelledby=":R5al9kl6:"
                    id=":R5al9kl6:"
                    class="MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input mui-style-1huuoxu">
                    <div class="mui-style-9e6j7t">
                      <svg
                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-style-675ts4"
                        focusable="false"
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        data-testid="LanguageIcon">
                        <path
                          d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"></path>
                      </svg>
                      <p class="MuiTypography-root MuiTypography-body2 mui-style-12anx9b">
                        en
                      </p>
                    </div>
                  </div>
                  <input
                    aria-hidden="true"
                    tabindex="-1"
                    class="MuiSelect-nativeInput mui-style-1k3x8v3"
                    value="en"
                  /><svg
                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined mui-style-yop3gh"
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="ArrowDropDownIcon"
                  >
                    <path d="M7 10l5 5 5-5z"></path>
                  </svg>
                  <fieldset
                    aria-hidden="true"
                    class="MuiOutlinedInput-notchedOutline mui-style-nqlg3w"
                  >
                    <legend class="mui-style-hdw1oc">
                      <span class="notranslate"></span>
                    </legend>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <div class="mui-style-1vk76n2">
    <span
      style="
        box-sizing: border-box;
        display: inline-block;
        overflow: hidden;
        width: 110px;
        height: 20px;
        background: none;
        opacity: 1;
        border: 0;
        margin: 0;
        padding: 0;
        position: relative;
      "
      >
      <!-- <img
        alt="VISA logo"
        src="https://corporatehospitality.paris2024.org/_next/static/media/visaMobileBannerLogo.340ff8ca.webp?imwidth=96"
        decoding="async"
        data-nimg="fixed"
        style="
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          box-sizing: border-box;
          padding: 0;
          border: none;
          margin: auto;
          display: block;
          width: 0;
          height: 0;
          min-width: 100%;
          max-width: 100%;
          min-height: 100%;
          max-height: 100%;
        " /><noscript
        ><img
          alt="VISA logo"
          srcSet="https://corporatehospitality.paris2024.org/_next/static/media/visaMobileBannerLogo.340ff8ca.webp?imwidth=96 1x, https://corporatehospitality.paris2024.org/_next/static/media/visaMobileBannerLogo.340ff8ca.webp?imwidth=256 2x"
          src="https://corporatehospitality.paris2024.org/assets/images/Header/visaEnglishLogo.svg?imwidth=256"
          decoding="async"
          data-nimg="fixed"
          style="
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            box-sizing: border-box;
            padding: 0;
            border: none;
            margin: auto;
            display: block;
            width: 0;
            height: 0;
            min-width: 100%;
            max-width: 100%;
            min-height: 100%;
            max-height: 100%;
          "
          loading="lazy" /></noscript
    > -->
  </span>
    <p class="MuiTypography-root MuiTypography-body1 mui-style-s244od">
      The Official Way to Pay
    </p>
  </div>
</header>
